import type { DisplayMode, LinkPolicy } from './presentation.ts';

export const RETENTION_DAYS_MIN = 1;
export const RETENTION_DAYS_MAX = 730;
export const VENDOR_INSTRUCTIONS_MAX_CHARS = 4000;

export const PLATFORM_DEFAULTS = {
  linkPolicy: 'vendor_origins',
  displayModes: ['floating', 'inline'],
  aiLabel: 'AI assistant',
  firstMessageNotice:
    'You are chatting with an AI assistant. It can make mistakes, so check important results.',
  creditLimitMessage:
    'Your organization has used its assistant allowance for this month. Contact your administrator to raise it.',
  retentionDays: 90,
  sessionIdleTimeoutSeconds: 12 * 3600,
  sessionMaxAgeSeconds: 7 * 86_400,
  sessionLifetimeSecondsMin: 60,
  sessionLifetimeSecondsMax: 30 * 86_400,
  mcpTokenTtlSecondsMax: 3600,
  grantMaxAgeDays: 90,
  grantMaxAgeDaysMax: 365,
  apiHost: 'api.plato.example',
  embedHost: 'embed.plato.example',
  userContentDomain: 'plato-usercontent.example',
} as const satisfies {
  linkPolicy: LinkPolicy;
  displayModes: readonly DisplayMode[];
  [key: string]: unknown;
};
